class Header {
  constructor(element) {
    this.header = element;
    this.hamburger = this.header.querySelector('.header__hamburger');
    this.mobileMenu = this.header.querySelector('.header__mobile-menu');
    this.isOpen = false;

    this.init();
  }

  init() {
    if (!this.hamburger || !this.mobileMenu) return;

    this.hamburger.addEventListener('click', () => this.toggleMenu());

    // Close menu when clicking outside
    document.addEventListener('click', (e) => {
      if (this.isOpen && !this.header.contains(e.target)) {
        this.closeMenu();
      }
    });

    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeMenu();
      }
    });
  }

  toggleMenu() {
    if (this.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    this.isOpen = true;
    this.hamburger.classList.add('header__hamburger--active');
    this.mobileMenu.classList.add('header__mobile-menu--open');
    this.hamburger.setAttribute('aria-expanded', 'true');

    // Focus first menu item for accessibility
    const firstLink = this.mobileMenu.querySelector('.header__mobile-link');
    if (firstLink) {
      firstLink.focus();
    }
  }

  closeMenu() {
    this.isOpen = false;
    this.hamburger.classList.remove('header__hamburger--active');
    this.mobileMenu.classList.remove('header__mobile-menu--open');
    this.hamburger.setAttribute('aria-expanded', 'false');
  }
}

// Initialize header when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const headerElement = document.querySelector('.header');
  if (headerElement) {
    new Header(headerElement);
  }
});
